import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	standardOfferAITitle: {
		id: 'upgrade-free-pool-target-experiment.Confluence-Standard-Offer-AI-Modal.title',
		defaultMessage: 'Work smarter, not harder',
		description: 'Title for the Confluence Standard Offer AI modal',
	},
	standardOfferAISubtitle: {
		id: 'upgrade-free-pool-target-experiment.Confluence-Standard-Offer-AI-Modal.subtitle',
		defaultMessage:
			'Leave the busywork to AI - summarize content, turn notes into docs, and more. Try Standard free for 14 days.',
		description: 'Subtitle for the Confluence Standard Offer AI modal',
	},
	aiBenefitsNotesToDocs: {
		id: 'upgrade-free-pool-target-experiment.Confluence-Standard-Offer-AI-Modal.aiBenefitsNotesToDocs',
		defaultMessage: 'Turn messy notes into polished docs',
		description: 'First message for the Confluence Standard Offer AI modal',
	},
	aiBenefitsSummarizePages: {
		id: 'upgrade-free-pool-target-experiment.Confluence-Standard-Offer-AI-Modal.aiBenefitsSummarizePages',
		defaultMessage: 'Summarize and catch up on pages',
		description: 'Second message for the Confluence Standard Offer AI modal',
	},
	aiBenefitsTone: {
		id: 'upgrade-free-pool-target-experiment.Confluence-Standard-Offer-AI-Modal.aiBenefitsTone',
		defaultMessage: 'Engage your audience with the right tone',
		description: 'Third message for the Confluence Standard Offer AI modal',
	},
	standardOfferAIDisclaimerText: {
		id: 'upgrade-free-pool-target-experiment.Confluence-Standard-Offer-AI-Modal.disclaimerText',
		defaultMessage:
			'Free 14-day Standard plan trial. Cancel or downgrade anytime. We’ll remind you before your trial ends.',
		description: 'Disclaimer text for the Confluence Standard Offer AI modal',
	},
	standardOfferAIPrimaryCTA: {
		id: 'upgrade-free-pool-target-experiment.Confluence-Standard-Offer-AI-Modal.primaryCTA',
		defaultMessage: 'Try it free',
		description: 'Primary CTA text for the Confluence Standard Offer AI modal',
	},
	standardOfferAISecondaryCTA: {
		id: 'upgrade-free-pool-target-experiment.Confluence-Standard-Offer-AI-Modal.secondaryCTA',
		defaultMessage: 'Not now',
		description: 'Secondary CTA text for the Confluence Standard Offer AI modal',
	},
});
